import Navbar from "./components/Navbar";
import FooterSection from "./components/FooterSection";

export default function NewFourCroPage() {
  return (
    <div className="min-h-screen bg-[#fff8ef] text-[#171717] overflow-hidden">
      <div className="fixed inset-0 pointer-events-none opacity-70" style={{ background: "radial-gradient(circle at 12% 18%, rgba(255,126,78,0.30), transparent 18%), radial-gradient(circle at 82% 14%, rgba(255,205,82,0.20), transparent 20%), radial-gradient(circle at 74% 68%, rgba(89,170,255,0.20), transparent 18%)" }} />
      <Navbar />
      <main className="relative z-10 pt-[110px] pb-20">
        <section className="pb-12 border-b border-[#171717]/8">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-[1fr_1fr] gap-6 items-stretch">
              <div className="rounded-[34px] border border-[#171717]/10 bg-[linear-gradient(135deg,rgba(255,240,219,0.94),rgba(255,255,255,0.84))] p-8 lg:p-10 shadow-[0_18px_50px_rgba(23,23,23,0.05)]">
                <p className="text-[11px] uppercase tracking-[0.24em] text-[#6b6b6b] font-bold mb-4">Service • AI CRO</p>
                <h1 className="text-5xl md:text-6xl font-black tracking-[-0.06em] leading-[0.94] mb-5">Improve conversion by matching the page to the visitor, not forcing every visitor through one page logic.</h1>
                <p className="text-[#4f4f4f] text-lg leading-relaxed max-w-2xl mb-8">AI CRO is where Flowvory connects message relevance, trust placement, segmentation, and decision support so more of the right traffic turns into revenue-quality actions.</p>
                <div className="flex flex-wrap gap-4">
                  <button onClick={() => window.dispatchEvent(new Event("flowvory:open-strategy"))} className="px-7 py-4 rounded-full bg-[#171717] text-[#fff8ef] text-base font-bold shadow-[8px_8px_0_rgba(255,126,78,0.20)]">Book a Call</button>
                  <div className="px-5 py-4 rounded-[22px] bg-white/75 border border-[#171717]/10 text-sm font-semibold">Designed for teams that care about conversion quality, not just superficial lift.</div>
                </div>
              </div>
              <div className="grid gap-4">
                {[
                  ["Intent mismatch", "The visitor arrives with one question and the page answers a different one."],
                  ["Trust friction", "Proof exists, but it is buried too late or shown in the wrong place."],
                  ["Static experience", "High-intent and low-intent users are pushed through the same generic path."],
                ].map(([title, text], idx) => (
                  <div key={title} className={`rounded-[28px] border border-[#171717]/10 p-6 shadow-[0_18px_50px_rgba(23,23,23,0.05)] ${idx === 1 ? "bg-[#171717] text-white rotate-[-1.4deg]" : idx === 2 ? "bg-[#fff0db] rotate-[1deg]" : "bg-white/84"}`}>
                    <h3 className="text-2xl font-black tracking-[-0.04em] mb-3">{title}</h3>
                    <p className={`leading-relaxed ${idx === 1 ? "text-white/76" : "text-[#4f4f4f]"}`}>{text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 border-b border-[#171717]/8">
          <div className="max-w-7xl mx-auto px-6 overflow-x-auto">
            <div className="min-w-[860px] rounded-[30px] border border-[#171717]/10 bg-white/86 shadow-[0_18px_50px_rgba(23,23,23,0.05)] overflow-hidden">
              <div className="grid grid-cols-[1.2fr_1fr_1fr_1fr] bg-[#171717] text-[#fff8ef] text-sm font-bold uppercase tracking-[0.16em]">
                <div className="px-5 py-4">Journey stage</div>
                <div className="px-5 py-4">Typical page</div>
                <div className="px-5 py-4">Flowvory view</div>
                <div className="px-5 py-4">Impact</div>
              </div>
              {[
                ["First click", "Generic promise", "Segment-aware message", "Faster trust"],
                ["Mid-evaluation", "Feature dump", "Decision guidance", "Less friction"],
                ["CTA moment", "Same ask for everyone", "Intent-matched CTA", "Higher quality conversion"],
              ].map((row, idx) => (
                <div key={row[0]} className={`grid grid-cols-[1.2fr_1fr_1fr_1fr] text-sm ${idx % 2 === 0 ? "bg-white/80" : "bg-[#fff4e8]"}`}>
                  {row.map((cell) => (
                    <div key={cell} className="px-5 py-4 border-t border-[#171717]/8 leading-relaxed">{cell}</div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[0.95fr_1.05fr] gap-6 items-start">
            <div className="rounded-[30px] border border-[#171717]/10 bg-[#171717] text-[#fff8ef] p-7">
              <p className="text-[10px] uppercase tracking-[0.22em] text-white/45 font-bold mb-3">What high-intent visitors usually need from the page</p>
              <blockquote className="text-2xl font-black tracking-[-0.04em] leading-snug mb-4">“A site converts better when it feels more relevant, more trustworthy, and easier to decide on.”</blockquote>
              <p className="text-white/62 text-sm">Flowvory, conversion systems and decision design</p>
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              {[
                "We work on the business logic behind conversion, not just button color theater.",
                "We care about revenue quality, not just inflated conversion vanity.",
                "The strongest CRO work comes from connecting acquisition, page structure, and offer framing.",
                "Current model: one lead client per quarter, deeper involvement, sharper prioritization.",
              ].map((item, idx) => (
                <div key={item} className={`rounded-[24px] border border-[#171717]/10 p-5 text-sm leading-relaxed shadow-[0_18px_50px_rgba(23,23,23,0.05)] ${idx % 2 === 0 ? "bg-white/86" : "bg-[#dff3ff]"}`}>{item}</div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
